import { STAGES_FIELDS } from './stages';

export const STORE_NAME = 'insurance';

const DATA_ACTIONS = {
  RESET_DATA: `${STORE_NAME}/reset-data`,
  UPDATE_DATA_DISABLED: `${STORE_NAME}/update-data/disabled`,
  UPDATE_DATA_ERRORS: `${STORE_NAME}/update-data/errors`,
  UPDATE_DATA_FIELDS: `${STORE_NAME}/update-data/fields`,
  UPDATE_DATA_HIDDEN: `${STORE_NAME}/update-data/hidden`,
  UPDATE_DATA_VALUES: `${STORE_NAME}/update-data/values`,
};

export const PAGES_ACTIONS = {
  RESET_PAGES: `${STORE_NAME}/reset-pages`,
  UPDATE_PAGES_DISABLED: `${STORE_NAME}/update-pages/disabled`,
  UPDATE_PAGES_ERRORS: `${STORE_NAME}/update-pages/errors`,
  UPDATE_PAGES_LOADINGS: `${STORE_NAME}/update-pages/loadings`,
  UPDATE_PAGES_PATCHING: `${STORE_NAME}/update-pages/patching`,
  UPDATE_PAGES_WARNINGS: `${STORE_NAME}/update-pages/warnings`,
};

const DRIVERS_ACTIONS = {
  GET_DRIVERS: `${STORE_NAME}/pages/drivers/get`,
  UPDATE_DRIVERS: `${STORE_NAME}/pages/drivers/update`,
};

const POLICYHOLDER_ACTIONS = {
  GET_POLICYHOLDER: `${STORE_NAME}/pages/policyholder/get`,
  UPDATE_POLICYHOLDER: `${STORE_NAME}/pages/policyholder/update`,
};

const VEHICLE_INFORMATION_ACTIONS = {
  GET_VEHICLE_INFORMATION: `${STORE_NAME}/pages/vehicle-information/get`,
  UPDATE_VEHICLE_INFORMATION: `${STORE_NAME}/pages/vehicle-information/update`,
};

const SAGA_ACTIONS = {
  ...DRIVERS_ACTIONS,
  ...POLICYHOLDER_ACTIONS,
  ...VEHICLE_INFORMATION_ACTIONS,
  //
  CREATE_NEW: `${STORE_NAME}/pages/create-new`,
  CREATE_NEW_INSURANCE: `${STORE_NAME}/stages/${STAGES_FIELDS.CREATE_NEW_INSURANCE}`,
  //
  GET_APPLICATION: `${STORE_NAME}/stages/${STAGES_FIELDS.GET_APPLICATION}`,
  GET_CAR_INSTANCE: `${STORE_NAME}/stages/${STAGES_FIELDS.GET_CAR_INSTANCE}`,
  GET_CUSTOMERS: `${STORE_NAME}/stages/${STAGES_FIELDS.GET_CUSTOMERS}`,
  GET_DRIVER_CUSTOMERS: `${STORE_NAME}/stages/${STAGES_FIELDS.GET_DRIVER_CUSTOMERS}`,
  GET_INSURANCE_ORDER: `${STORE_NAME}/stages/${STAGES_FIELDS.GET_INSURANCE_ORDER}`,
  GET_INSURER_CUSTOMER: `${STORE_NAME}/stages/${STAGES_FIELDS.GET_INSURER_CUSTOMER}`,
  GET_OWNER_CUSTOMER: `${STORE_NAME}/stages/${STAGES_FIELDS.GET_OWNER_CUSTOMER}`,
  GET_WORKSHEET: `${STORE_NAME}/stages/${STAGES_FIELDS.GET_WORKSHEET}`,
  //
  // eslint-disable-next-line max-len
  MOVE_TO_INSURANCE_PRODUCTS_WITH_PARAMS: `${STORE_NAME}/stages/${STAGES_FIELDS.MOVE_TO_INSURANCE_PRODUCTS_WITH_PARAMS}`,
  MOVE_TO_INSURER_INFO_STATE: `${STORE_NAME}/stages/${STAGES_FIELDS.MOVE_TO_INSURER_INFO_STATE}`,
  //
  SELECT_BRAND: `${STORE_NAME}/stages/${STAGES_FIELDS.SELECT_BRAND}`,
  SELECT_MODEL: `${STORE_NAME}/stages/${STAGES_FIELDS.SELECT_MODEL}`,
  SELECT_VERSION: `${STORE_NAME}/stages/${STAGES_FIELDS.SELECT_VERSION}`,
  //
  UPDATE_CAR_INSTANCE: `${STORE_NAME}/stages/${STAGES_FIELDS.UPDATE_CAR_INSTANCE}`,
  UPDATE_DRIVER_CUSTOMERS: `${STORE_NAME}/stages/${STAGES_FIELDS.UPDATE_DRIVER_CUSTOMERS}`,
  UPDATE_INSURER_CUSTOMER: `${STORE_NAME}/stages/${STAGES_FIELDS.UPDATE_INSURER_CUSTOMER}`,
  UPDATE_OWNER_CUSTOMER: `${STORE_NAME}/stages/${STAGES_FIELDS.UPDATE_OWNER_CUSTOMER}`,
  //
  VIN_RECOGNITION: `${STORE_NAME}/stages/${STAGES_FIELDS.VIN_RECOGNITION}`,
};

export const STAGES_ACTIONS = {
  RESET_STAGES: `${STORE_NAME}/reset-stages`,
  UPDATE_STAGES_ERRORS: `${STORE_NAME}/update-stages/errors`,
  UPDATE_STAGES_LOADINGS: `${STORE_NAME}/update-stages/loadings`,
};

export const ACTIONS = {
  ...DATA_ACTIONS,
  ...PAGES_ACTIONS,
  ...SAGA_ACTIONS,
  ...STAGES_ACTIONS,
};
